import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getAgreement } from '../AgreementsQueries';

export const useAgreementItem = ({ currentAgreementItemId }: { currentAgreementItemId: number | null | undefined }) => {
    const dispatch = useDispatch();
    const variables = useMemo(() => ({ contractChangeId: currentAgreementItemId }), [currentAgreementItemId]);

    const [agreementItemData, agreementItemStatus, , agreementItemDataRequest] = useRequest({
        requestId: 'agreementItem',
        query: getAgreement,
        variables,
        withEffect: !!currentAgreementItemId,
    });
    const [resetAgreementItem] = useResetStoreData({ requestId: 'agreementItem' });

    const refreshData = useCallback(() => {
        dispatch(agreementItemDataRequest(variables));
    }, [agreementItemDataRequest, dispatch, variables]);

    return {
        agreementItemData: agreementItemData?.uerContractChange,
        agreementItemStatus,
        resetAgreementItem,
        refreshData,
    };
};
